import { render, staticRenderFns } from "./DashboardViewAgent.vue?vue&type=template&id=3c3a62c4"
import script from "./DashboardViewAgent.vue?vue&type=script&lang=js"
export * from "./DashboardViewAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports